// extracted by mini-css-extract-plugin
export default {"create":"create-plants-list_create__LL7Nq","header":"create-plants-list_header__nGHdI","backward":"create-plants-list_backward__a+cV9","rotate":"create-plants-list_rotate__ZENmK"};